/* eslint-disable import/no-named-as-default-member */
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import * as en from "@/config/i18n/en";
import * as fr from "@/config/i18n/fr";
import { APP_DEFAULT_LOCALE } from "@/services/language";

/**
 * Manually add imported languages in ressources
 */
const resources = {
  en,
  fr,
};

const supportedLngs = Object.keys(resources);

/**
 * Init `i18next` instance with supported languages resources (translations files).
 *
 * - Supported languages are `fr` and `en`.
 *
 * - The included language detector plugin looks for a saved language
 *   value in this order: querystring, cookie, localStorage,
 *   sessionStorage, navigator, htmlTag.
 *
 * - The fallback language is `en` in case of the detected language
 *   is not part of supported languages.
 *
 */
export const initI18n = () => {
  i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      supportedLngs,
      fallbackLng: APP_DEFAULT_LOCALE,
      interpolation: { escapeValue: false },
      showSupportNotice: false,
    });

  return i18next;
};
